import classNames from 'classnames';

interface TabToggleProps<T extends string> {
  onChange: (tabType: T) => void;
  option1: { label: string; value: T };
  option2: { label: string; value: T };
  selectedOption: T;
}

const TabToggle = <T extends string>({
  onChange,
  option1,
  option2,
  selectedOption,
}: TabToggleProps<T>) => {
  return (
    <div className="tab-toggle__wrapper ch-mt--2 ch-width--12">
      <div
        aria-label="Tab toggle"
        className={`tab-toggle ch-display--flex ch-relative ch-width--12 ${
          selectedOption === option1.value
            ? 'tab-toggle--option1'
            : 'tab-toggle--option2'
        }`}
        role="tablist"
      >
        <div
          aria-selected={selectedOption === option1.value}
          className={classNames(
            'ch-fs--3 ch-fw--400 ch-text--center ch-pb--1 ch-color--ac-black',
            {
              'ch-fw--500': selectedOption === option1.value ? 'selected' : '',
            }
          )}
          onClick={() => onChange(option1.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') onChange(option1.value);
          }}
          role="tab"
          tabIndex={0}
        >
          {option1.label}
        </div>
        <div
          aria-selected={selectedOption === option2.value}
          className={classNames(
            'ch-fs--3 ch-fw--400 ch-text--center ch-pb--1 ch-color--ac-black',
            { 'ch-fw--500': selectedOption === option2.value ? 'selected' : '' }
          )}
          onClick={() => onChange(option2.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') onChange(option2.value);
          }}
          role="tab"
          tabIndex={0}
        >
          {option2.label}
        </div>
        <div className="tab-toggle__indicator ch-bg--ac-blue ch-width--6 ch-absolute" />
      </div>
    </div>
  );
};

export default TabToggle;
